export const gadsEditor: Record<string, string> = {
  'gads.tab': 'Campaign Editor',
  'gads.title': 'Ngân sách Google Ads',
  'gads.subtitle':
    'Tăng ngân sách ngay trên Google thì bị hỏi xác minh danh tính. Đi qua đây thì không, nên System tự đặt trần thay.',

  'gads.account': 'Tài khoản',
  'gads.reload': 'Tải lại',
  'gads.campaign': 'Chiến dịch',
  'gads.status': 'Trạng thái',
  'gads.budget': 'Ngân sách ngày',
  'gads.budgetShared': 'Ngân sách dùng chung',
  'gads.sharedWarning': 'Ngân sách này dùng chung cho {n} chiến dịch. Sửa là sửa hết.',
  'gads.edit': 'Sửa',
  'gads.filter': 'Lọc theo text…',
  'gads.rowCount': '{shown} / {total} dòng',
  'gads.noCampaigns': 'Tài khoản này chưa có chiến dịch nào.',

  'gads.dialog.title': 'Sửa ngân sách ngày',
  'gads.dialog.current': 'Hiện tại',
  'gads.dialog.new': 'Số mới',
  'gads.dialog.change': 'Thay đổi',
  'gads.dialog.save': 'Lưu',
  'gads.dialog.cancel': 'Huỷ',
  'gads.dialog.bigJump': 'Mức tăng này lớn bất thường. Xem lại con số trước khi lưu.',

  'gads.queue.title': 'Thay đổi chờ ({n})',
  'gads.queue.apply': 'Gửi',
  'gads.queue.applying': 'Đang gửi…',
  'gads.queue.discard': 'Bỏ',
  'gads.queue.rebase': 'Giữ số tôi muốn',
  'gads.queue.staleNow': 'Google hiện đang là {live}.',
  'gads.queue.summary':
    '{account} · {up} tăng, {down} giảm · tổng ngày {before} → {after}',
  'gads.queue.bigJumps': '{n} thay đổi tăng từ một nửa trở lên.',
  'gads.queue.confirmTitle': 'Gửi các thay đổi này lên Google Ads?',
  'gads.queue.confirmBody':
    '{n} thay đổi trên {account}: {up} tăng, {down} giảm. Tổng ngân sách ngày {before} → {after}.',

  'gads.cap.title': 'Bị trần ngân sách chặn',
  'gads.cap.cumulative':
    'Trong 24 giờ, ngân sách này chỉ được lên tới {ceiling}, tính từ {anchor} là mức thấp nhất của nó.',
  'gads.cap.increase_count': 'Ngân sách này đã được tăng {used} lần trong 24 giờ.',
  'gads.cap.account_budgets': 'Tài khoản này đã tăng {used} ngân sách trong 24 giờ.',
  'gads.cap.over_cap_spent':
    'Lượt vượt trần của ngân sách này trong khoảng thời gian hiện tại đã dùng hết, kể cả một lần bị lỗi. Chờ thêm, hoặc sửa thẳng trên Google Ads.',
  'gads.cap.confirm': 'Vẫn sửa',
  'gads.cap.final': 'Lần này không xác nhận để đi tiếp được.',

  'gads.deny.not_a_direct_user': 'Google Ads không liệt bạn là người dùng của tài khoản này.',
  'gads.deny.invitation_pending': 'Bạn có lời mời vào tài khoản này. Mở hộp thư và chấp nhận trước đã.',
  'gads.deny.email_mismatch':
    'Bạn đang đăng nhập bằng {email}. Google Ads chỉ có người dùng thuộc: {domains}.',
  'gads.deny.robot_not_invited':
    'Tài khoản robot của System chưa được mời vào tài khoản này. Cần quản trị mời nó.',
  'gads.noAccounts': 'Chưa có tài khoản Google Ads nào mở cho bạn.',

  'gads.err.quota': 'Hết hạn mức Google hôm nay. Sửa thẳng trên Google Ads, hoặc đợi ngày mai.',
  'gads.err.permission': 'Google từ chối. Có thể quyền trên tài khoản đã thay đổi.',
  'gads.err.generic': 'Không thực hiện được.',

  'gads.ops.title': 'System đã làm gì ở đây',
  'gads.ops.when': 'Lúc',
  'gads.ops.who': 'Ai',
  'gads.ops.what': 'Thay đổi',
  'gads.ops.result': 'Kết quả',
  'gads.ops.empty': 'Chưa có gì.',
  'gads.ops.result.ok': 'Đã ghi',
  'gads.ops.result.ok_over_cap': 'Đã ghi, vượt trần',
  'gads.ops.result.blocked_cap': 'Bị chặn',
  'gads.ops.result.pending': 'Chờ xác nhận',
  'gads.ops.result.denied': 'Từ chối, không có quyền',
  'gads.ops.result.error': 'Lỗi',
  'gads.ops.result.inflight': 'Đang chạy',
  'gads.ops.result.stale': 'Không ghi, số đã đổi',
  'gads.ops.result.confirmed': 'Đã xác nhận',
  'gads.ops.result.expired': 'Hết hạn, không xác nhận',

  'gads.access.title': 'Ai được dùng',
  'gads.access.hint':
    'Theo từng người, không theo chức danh. Có tên ở đây không có nghĩa là ghi được vào một tài khoản cụ thể; Google vẫn quyết từng tài khoản.',
  'gads.access.email': 'email công ty',
  'gads.access.note': 'lý do (không bắt buộc)',
  'gads.access.add': 'Thêm',
  'gads.access.remove': 'Gỡ',
  'gads.access.empty': 'Hiện mới chỉ có admin.',

  // Bridge: bật/tạm dừng campaign qua extension, chạy bằng chính phiên Google của người dùng.
  'gads.bridge.outdated':
    'Extension đang chạy bản {have}, cần bản {need} trở lên. Vào chrome://extensions, mở Chi tiết của GAds Campaign Editor xem mục Nguồn có trỏ đúng thư mục .output\chrome-mv3 không (KHÔNG phải chrome-mv3-dev), bấm Gỡ rồi Nạp lại (Load unpacked) đúng thư mục đó, sau đó tải lại trang.',
  'gads.bridge.title': 'Extension',
  'gads.bridge.ready': 'Extension sẵn sàng cho {account}.',
  'gads.bridge.no_extension':
    'Chưa thấy extension cầu nối Google Ads. Cài extension rồi tải lại trang này.',
  'gads.bridge.unknown_account':
    'Tài khoản Google bạn đang đăng nhập trong trình duyệt không thấy {here}. Kiểm tra xem có đúng tài khoản Google đó không, rồi tải lại trang.',
  'gads.bridge.outdatedShort': 'Extension cũ hơn mức trang này cần. Cập nhật extension rồi tải lại trang.',
  'gads.bridgeSwitch.title': 'Thay đổi qua extension',
  'gads.bridgeSwitch.on': 'Đang bật: extension được ghi thay đổi lên Google Ads',
  'gads.bridgeSwitch.off': 'Đang tắt: không thay đổi nào đi qua extension',
  'gads.bridgeSwitch.turnOff': 'Tắt',
  'gads.bridgeSwitch.turnOn': 'Bật',
  'gads.bridgeSwitch.offNotice':
    'Quản trị viên đã tắt các thay đổi qua extension. Chưa gửi gì tới Google.',
  'gads.bridge.pause': 'Tạm dừng',
  'gads.bridge.resume': 'Bật lại',
  'gads.bridge.running': 'Xác nhận trong extension…',
  'gads.bridge.timeout':
    'Không ai trả lời bảng xác nhận. Chưa gửi gì cả; dòng nhật ký để mở cho tới khi được chốt.',
  'gads.bridge.result.ok': 'Xong.',
  'gads.bridge.result.unconfirmed':
    'Google trả lời nhưng không xác nhận đã áp. Kiểm tra lại campaign trước khi thử tiếp.',
  'gads.bridge.result.reauth':
    'Google đòi xác minh danh tính. Làm tay đúng thao tác đó một lần trên tab Ads, xác minh xong rồi quay lại.',
  'gads.bridge.result.refused': 'Extension từ chối: {detail}',
  'gads.bridge.result.error': 'Không chạy được: {detail}',
  'gads.bridge.notSettled':
    'Đã gửi xong nhưng không ghi được kết quả vào sổ ({detail}). Dòng nhật ký để mở cho tới khi được chốt.',
  'gads.ops.result.unconfirmed': 'Google không xác nhận',
  'gads.ops.result.reauth': 'Google đòi xác minh',
  'gads.ops.result.refused': 'Extension từ chối',
  'gads.ops.result.unsettled': 'Không báo kết quả về',

  // Tab của chính trang, bố cục theo extension: một bảng, một sổ, một danh sách người dùng.
  'gads.view.campaigns': 'Chiến dịch',
  'gads.view.ops': 'Nhật ký',
  'gads.view.access': 'Ai được dùng',
  'gads.metricsWindow': 'Số liệu {days} ngày gần nhất',
  'gads.metric.impressions': 'Lượt hiển thị',
  'gads.metric.cost': 'Chi phí',
  'gads.metric.convValuePerCost': 'Giá trị ch.đổi / chi phí',
  'gads.metric.ctr': 'CTR',
  'gads.metric.avgCpc': 'CPC TB',
  'gads.metric.conversions': 'Lượt ch.đổi',
  'gads.metric.convRate': 'Tỷ lệ ch.đổi',
  'gads.metric.installsPerMille': 'Cài đặt / nghìn h.thị',
  'gads.metric.costPerConv': 'Chi phí / ch.đổi',
  'gads.metric.convValue': 'Giá trị ch.đổi',
  'gads.filterStatus.campaign': 'Trạng thái chiến dịch',
  'gads.filterStatus.adGroup': 'Trạng thái nhóm quảng cáo',
  'gads.filterStatus.all': 'Tất cả',
  'gads.filterStatus.enabled': 'Đang bật',
  'gads.filterStatus.enabledPaused': 'Đang bật, Tạm dừng',
  'gads.stats.needExtension':
    'Các cột số liệu đọc qua extension Campaign Editor để khớp đúng con số trên Google. Máy này chưa có extension nên cột số đang trống.',
  'gads.stats.failed': 'Không đọc được số liệu: {error}',
  'gads.stats.timeout':
    'Extension không trả lời khi đọc số liệu. Nếu vừa cập nhật extension, hãy vào chrome://extensions, Gỡ rồi Nạp lại (Load unpacked) thư mục .output\chrome-mv3, sau đó tải lại trang.',
  'gads.stats.truncated': 'Danh sách số liệu đã đầy một trang nên có thể còn chiến dịch chưa có số.',
  'gads.queue.empty': 'Chưa có thay đổi nào. Gõ ngân sách hoặc mục tiêu mới vào bảng để bắt đầu.',
  // tROAS gõ theo phần trăm như cách người ta nói; tCPA là tiền.
  'gads.bid': 'Mục tiêu',
  // Hai cấp dưới campaign, mở ra bằng cách bấm tên ở cấp trên.
  'gads.view.adGroups': 'Nhóm quảng cáo',
  'gads.view.ads': 'Quảng cáo',
  'gads.adGroup': 'Nhóm quảng cáo',
  'gads.headlines': 'Tiêu đề',
  'gads.descriptions': 'Mô tả',
  'gads.noAdGroups': 'Chiến dịch này không có nhóm quảng cáo nào.',
  'gads.noAds': 'Nhóm này không có quảng cáo nào.',
  // Ảnh, video và HTML5 đọc qua extension: Google Ads API chỉ biết tên tệp zip của một playable.
  'gads.assets.images': 'Hình ảnh',
  'gads.assets.videos': 'Video',
  'gads.assets.html5': 'HTML5',
  'gads.assets.loading': 'Đang đọc thành phần từ Google Ads…',
  'gads.assets.needExtension':
    'Ảnh, video và HTML5 cần extension Campaign Editor trên máy này. Chữ vẫn đọc qua API nên hiện bình thường.',
  'gads.assets.failed': 'Không đọc được thành phần: {error}',
  'gads.assets.unrecognised':
    'Có {count} thành phần Google trả về mà extension chưa đọc được — giao thức nội bộ có thể đã đổi.',
  'gads.assets.openPlayable': 'Chạy thử',
  'gads.assets.closePlayable': 'Đóng',
  'gads.assets.openInTab': 'Mở tab mới',
  'gads.assets.files': '{count} tệp',
  'gads.assets.truncated':
    'Danh sách thành phần đã đầy một trang nên có thể còn thiếu — những quảng cáo ở cuối có thể chưa đọc tới.',
  'gads.assets.otherAds':
    'Có {count} thành phần thuộc quảng cáo không nằm trong bảng này (đã tạm dừng hoặc đã xoá).',
  'gads.assets.imageGone': 'Ảnh không tải được',
  'gads.assets.remove': 'Bỏ khỏi quảng cáo',
  'gads.assets.replace': 'Thay',
  'gads.assets.working': 'Đang gửi…',
  'gads.assets.fromAdGroup': 'Gắn ở nhóm quảng cáo',
  'gads.assets.pickFilter': 'Tìm theo tên tệp…',
  'gads.assets.pickCancel': 'Thôi',
  'gads.assets.pickLoading': 'Đang đọc thành phần của tài khoản…',
  'gads.assets.pickEmpty': 'Tài khoản này không có thành phần nào khác cùng loại.',
  'gads.assets.pickTruncated':
    'Danh sách đã đầy một trang nên có thể còn thành phần chưa hiện ra.',
  'gads.assets.editText': 'Sửa chữ',
  'gads.assets.textSaved': 'Đã lưu chữ.',
  'gads.assets.textMoved': 'Chữ này đã đổi kể từ lúc tải trang. Tải lại rồi thử lại.',
  'gads.assets.removed': 'Đã bỏ thành phần khỏi quảng cáo.',
  'gads.assets.replaced': 'Đã thay thành phần.',
  'gads.assets.none': 'Quảng cáo này không có ảnh, video hay HTML5 nào.',

  // Bảng thành phần, bố cục như màn Thành phần của Google.
  'gads.assets.component': 'Thành phần',
  'gads.assets.statusCol': 'Trạng thái',
  'gads.assets.status.eligible': 'Đủ điều kiện',
  'gads.assets.status.paused': 'Tạm dừng',
  'gads.assets.orientationCol': 'Hướng',
  'gads.assets.orientation.square': 'Hình vuông',
  'gads.assets.orientation.landscape': 'Ngang',
  'gads.assets.orientation.portrait': 'Dọc',
  'gads.assets.typeCol': 'Loại',
  'gads.assets.kind.headline': 'Tiêu đề',
  'gads.assets.kind.description': 'Mô tả',
  'gads.assets.kind.image': 'Hình ảnh',
  'gads.assets.kind.video': 'Video',
  'gads.assets.kind.html5': 'HTML5',
  'gads.perf.header': 'Hiệu suất',

  // Hiệu suất theo từng thành phần, đọc qua extension trong cùng khoảng ngày với bảng chiến dịch.
  'gads.perf.label.best': 'Tốt nhất',
  'gads.perf.label.good': 'Tốt',
  'gads.perf.label.low': 'Thấp',
  'gads.perf.label.learning': 'Đang tìm hiểu',
  'gads.perf.label.pending': 'Đang chờ',
  'gads.perf.label.unknown': 'Không rõ',
  'gads.perf.statsMissing':
    'Không thành phần nào trả về số liệu — bộ cột số liệu của extension có thể đã đổi. Chỗ này không phải số 0 thật.',
  'gads.perf.labelsUnmapped': '{count} thành phần có nhãn hiệu suất trang chưa đọc được.',
}
